import { ComponentType } from 'react';

import { Element, Processor } from '@/features/html2react/types';

import Script, { ScriptProps } from '../components/script';

interface LinkElement extends Element {
  props: Element['props'] & ScriptProps;
}

const script: Processor<LinkElement> = {
  priority: 10,
  name: 'script',
  test: ({ node }) => node?.component === 'script',
  processor: ({ node }) => {
    node.component = Script as ComponentType;
    return node;
  }
};

export default script;
